const APP_SOURCE = "map-discovery-reference";

function encoded(value) {
  return encodeURIComponent(value ?? "");
}

export function amapNavigationUrl(place) {
  if (!place?.mappable) {
    return `https://uri.amap.com/search?keyword=${encoded(
      [place.name, place.address].filter(Boolean).join(" ")
    )}&view=map&src=${APP_SOURCE}&coordinate=gaode&callnative=1`;
  }
  const destination = `${place.displayLng},${place.displayLat}`;
  return (
    "amapuri://route/plan/?" +
    `dlat=${place.displayLat}` +
    `&dlon=${place.displayLng}` +
    `&dname=${encoded(place.name)}` +
    "&dev=0&t=0"
  );
}

export function amapWebUrl(place) {
  if (!place?.mappable) {
    return `https://uri.amap.com/search?keyword=${encoded(
      [place.name, place.address].filter(Boolean).join(" ")
    )}&view=map&src=${APP_SOURCE}&coordinate=gaode&callnative=1`;
  }
  return (
    `https://uri.amap.com/marker?position=${place.displayLng},${place.displayLat}` +
    `&name=${encoded(place.name)}&src=${APP_SOURCE}&coordinate=gaode&callnative=1`
  );
}
